import { Component } from '@grafikr/components';

export default Component((node) => {
  const year = parseInt(node.getAttribute('data-year') ?? '0', 10);
  const month = parseInt(node.getAttribute('data-month') ?? '0', 10) - 1;
  const day = parseInt(node.getAttribute('data-day') ?? '0', 10);
  const hour = parseInt(node.getAttribute('data-hour') ?? '0', 10);
  const minute = parseInt(node.getAttribute('data-minute') ?? '0', 10);
  const daysText = node.getAttribute('data-days-text') ?? '';
  const hoursText = node.getAttribute('data-hours-text') ?? '';
  const minutesText = node.getAttribute('data-minutes-text') ?? '';
  const secondsText = node.getAttribute('data-seconds-text') ?? '';

  const countdownType = node.getAttribute('data-countdown-type');

  const targetDate = new Date(year, month, day, hour, minute);
  const outputDiv = document.createElement('div');
  node.appendChild(outputDiv);

  const updateCountdown = () => {
    const now = new Date();
    const diff = targetDate.getTime() - now.getTime();

    if (diff <= 0) {
      node.textContent = '';
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (countdownType === 'total_hours') {
      const totalHours = days * 24 + hours;
      outputDiv.textContent = `${totalHours}${hoursText} : ${minutes}${minutesText} : ${seconds}${secondsText}`;
    } else if (countdownType === '24_hours') {
      outputDiv.textContent = `${hours}${hoursText} : ${minutes}${minutesText} : ${seconds}${secondsText}`;
    } else {
      outputDiv.textContent = `${days}${daysText} : ${hours}${hoursText} : ${minutes}${minutesText} : ${seconds}${secondsText}`;
    }
  };

  updateCountdown();
  setInterval(updateCountdown, 1000);
});
